import { render, staticRenderFns } from "./RequirePlan.vue?vue&type=template&id=530ebcf4&scoped=true&"
import script from "./RequirePlan.vue?vue&type=script&lang=js&"
export * from "./RequirePlan.vue?vue&type=script&lang=js&"
import style0 from "./RequirePlan.vue?vue&type=style&index=0&id=530ebcf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530ebcf4",
  null
  
)

export default component.exports